import { gql, useQuery } from "@apollo/client";

export const ProfileFragment = gql`
  fragment ProfileFragment on Profile {
    id
    orgId
    age
    gender
    weight
    height
    activity
    goal
    customTarget
    proteinTarget
    carbsTarget
    fatTarget
    target
    bmr
    maintenance
    calculated
    updatedAt
  }
`;

// The profile, or null before the first save.
export const get = gql`
  query ProfileGet {
    viewer {
      id
      account {
        id
        profile {
          id
          get {
            ...ProfileFragment
          }
        }
      }
    }
  }
  ${ProfileFragment}
`;

export const save = gql`
  mutation ProfileSave($input: ProfileInput!) {
    viewer {
      account {
        profile {
          save(input: $input) {
            ...ProfileFragment
          }
        }
      }
    }
  }
  ${ProfileFragment}
`;

// After a save, `get` is read again rather than patched: the first save turns
// a cached null into a profile, which no normalized merge would do on its own.
export const AFTER_SAVE = { refetchQueries: ["ProfileGet"] };

// The daily target in kcal, or null when none is set — what the chat's panel
// and the day screen measure their totals against. `cache-first`: it changes
// only on a save, and a save refetches it.
export const useTarget = () => useTargets().calories;

// The same, with the macro targets: grams a day of each, null where none is
// set. What the totals measure each macro against.
export const useTargets = () => {
  const { data } = useQuery(get, { fetchPolicy: "cache-first" });
  const profile = data?.viewer?.account?.profile?.get;
  return {
    calories: profile?.target ?? null,
    protein: profile?.proteinTarget ?? null,
    carbs: profile?.carbsTarget ?? null,
    fat: profile?.fatTarget ?? null,
  };
};
